module.exports = __webpack_public_path__ + "static/media/peterpauldevries.765bfbe7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/peterpauldevries.webp
// module id = 222
// module chunks = 0